import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useClient from 'api/client';
import listDatasetTableColumns from 'api/DatasetTable/listDatasetTableColumns';
import { SearchFilter } from 'types/Filters';
import { PaginationItems } from 'types/Pagination';

interface TableColumnRows {
    name: string;
    typeName: string;
    columnUri: string;
}

export default function useTableColumns(filter: SearchFilter) {
    const params = useParams();
    const client = useClient();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [rows, setRows] = useState<TableColumnRows[]>([]);
    const [items, setItems] = useState<PaginationItems>({
        count: 0,
        pages: 0,
        page: 0,
    });
    const [showSearchbar, setShowSearchbar] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            if (params.uri) {
                const response = await client.query(
                    listDatasetTableColumns(params.uri, filter),
                );
                if (!response.errors) {
                    setItems(response.data.listDatasetTableColumns);
                    setRows(response.data.listDatasetTableColumns.nodes);
                    if (
                        response.data.listDatasetTableColumns.count !== 0 &&
                        !showSearchbar
                    ) {
                        setShowSearchbar(true);
                    }
                } else {
                    setError(true);
                }
            }
            setLoading(false);
        };

        if (client) {
            fetchData();
        }
    }, [client, params.uri, filter]);

    return { rows, error, loading, showSearchbar, items };
}
